<template>
  <div class="index">
    <div v-if="$store.state.org.userTrusts.length == 0">Loading your groups...</div>
    <div class="trust-link" v-for="(trust, index) in $store.state.org.userTrusts" :key="index">
      <GroupIndex :trust="trust"></GroupIndex>
    </div>
  </div>
</template>

<script>
import GroupIndex from '@trust/components/GroupIndex.vue'

export default {
  name: 'Index',
  components: {
    GroupIndex
  },
  data() {
      return {
      }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
}

</script>

<style>
.index {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  height: 100%;
  overflow-y: scroll;
  padding: 20px;
  padding-top: 40px;
  padding-right: 0;
  box-sizing: border-box;
  width: 100%;
}

@media screen and (max-device-width: 600px){
  .index {
    grid-template-columns: 1fr;
  }
}
</style>
